import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from '../../models/breadcrumb';
import { BaseComponent } from '../component-base';
import { SharedModule } from '../../shared.module';



@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',

})
export class NotFoundComponent extends BaseComponent implements OnInit {


   ngOnInit(): void {
  }

  get initBreadcrumb(): Breadcrumb {
    let breadcrumbDetails: Breadcrumb = {
      title: 'error.pageNotFound',
      current: 'error.pageNotFound',
      main: {
        title: 'common.main',
        link: '/home'
      }
    }
    return breadcrumbDetails;
  }

}
